import { createSlice } from '@reduxjs/toolkit';
import type { HistoryError, Links, MatchHistoryItem, Meta } from '../api/history-games.types';
import { fetchMatchHistory } from './history-games.thunk';

interface HistoryState {
  items: MatchHistoryItem[];
  loading: boolean;
  error: HistoryError | null;
  meta: Meta | null;
  links: Links | null;
}

const initialState: HistoryState = {
  items: [],
  loading: false,
  error: null,
  meta: null,
  links: null,
};

export const historySlice = createSlice({
  name: 'history',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMatchHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMatchHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.items;
        state.meta = action.payload.meta;
        state.links = action.payload.links;
      })
      .addCase(fetchMatchHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as HistoryError;
      });
  },
});

export default historySlice.reducer;
